module.exports = __webpack_public_path__ + "img/check.9bcf6df3.svg";